import React, {useEffect, useState} from 'react'
import {
    DialogTitle,
    DialogContent, Button, CircularProgress
} from '@material-ui/core'
import { Dialog } from 'components/shared/Dialog'
import PdfViewer from "components/pdf/PdfViewer";
import styles from './pdfModal.module.scss'
import CloseIcon from '@material-ui/icons/Close';
import strings from 'strings'
import {downloadFileByPayload, getAttachmentPDF} from "../../../../../actions/applicants";

/**
 * Shows an attachment PDF. Pass `loadPdf` (resolves to a Blob) and `onDownload` to show a PDF
 * that isn't an attachment; `title` overrides the dialog title.
 */
const Pdf = (props) => {
    const {
        open,
        onClose,
        pdf,
        loadPdf,
        onDownload,
        title
    } = props

    const [loading, setLoading] = useState(false)
    const [pdfFile, setPdfFile] = useState();

    const payloadAttachmentDownload = {
        applicationId: pdf?.applicationId,
        fileId: pdf?.uuid,
        fileName: pdf?.fileName
    }

    useEffect(() => {
        const load = loadPdf
            || (pdf && pdf.uuid ? () => getAttachmentPDF({fileId: pdf.uuid, applicationId: pdf.applicationId})() : null)
        if (!open || !load) return
        let cancelled = false
        setPdfFile(undefined)
        setLoading(true)
        Promise.resolve(load())
            .then(blob => { if (!cancelled) setPdfFile(blob) })
            .catch(() => { /* the request already shows the error */ })
            .finally(() => { if (!cancelled) setLoading(false) })
        return () => { cancelled = true }
    }, [open, pdf, loadPdf])

    const handleDownload = onDownload || (() => downloadFileByPayload(payloadAttachmentDownload)())

    return (

        <Dialog
            open={open}
            fullWidth={true}
            maxWidth='lg'
            onClose={onClose}
        >

            <div>
                <div className={styles.drawerTitle}>

                    <div className={styles.titleContainer}>
                        <DialogTitle>{title || strings.DOCUMENT_VIEW}</DialogTitle>
                    </div>

                    <div className={styles.actionContainer}>
                        <Button color='primary' variant='contained' onClick={handleDownload} className='mr-2'>
                            {strings.DOWNLOAD_PDF}
                        </Button>
                        <CloseIcon onClick={onClose} />
                    </div>

                </div>

                <DialogContent>
                    {loading ?
                        <div className={styles.loading}><CircularProgress size={24} color='inherit' /></div>
                        :
                        <PdfViewer pdf={pdfFile} />
                    }
                </DialogContent>
            </div>
        </Dialog >
    )
}

export default Pdf
